<template lang="pug">
div(v-if="mainData")
  .eachbox.border.border-grey-d9.rounded-8.items-center.my-12.mr-21.cursor-pointer.w-210.h-280.card.bg-grey-f2.transition.duration-300.ease-in-out(
    :class="{'bg-grey-f2': isExtend[index],'border-grey-d9': isExtend[index], 'hover:border-grey-d9' :isExtend[index] }"
    @mouseover="showExport(index)" @mouseleave="closeExport()" 
    v-for="(item,index) in mainData" ref="scrollPoint")  
    .flex.flex-col.relative(    
      :style="`height:${height}px;`"   background-color
      @click="extend(index)" )

      .flex.items-center.py-20.h-72.bg-white.rounded-t-8.px-8(:class="{'font-600':isExtend[index], 'cursor-pointer': $route.path != '/model' && $route.path != '/faq'}" )  
  
        Checkbox(:options="objectOrg(item)" :value="tablecheck" @changeValue="changeValue").w-24.mr-12
        div
          .text-16.wordDot.mb-4.font-700.text-main-0(:style="`font-size:${fontSize}px;`") {{item.data['filename']}}
          .text-12.wordDot.font-500 {{item.name}} 

      div(v-if="moreOption==index" @click="goDetail(item)").w-full.absolute.top-72.flex-col.justify-end.flex.items-center.transition.duration-300.ease-in-out.border
        .mask.opacity-80.bg-black.w-full.h-206.rounded-b-8       
        .absolute
          Button.w-178.mb-16(:text="$t('__globeButton.__export')"  type="borderSolid" @buttonClick='openExport(item)')
          Button.w-178.mb-24(:text="$t('__e5H7.__delete')" type="borderSolid" @buttonClick='openDelete(item)')
      .flex.px-16.pt-12.pb-16.flex-col  
        .text-16.h-37  {{tableBarAutoCheckFrequency(item.data.frequency[0])}}{{item.data.frequency[1] ? `, ${tableBarAutoCheckFrequencyDay(item.data.frequency[1])}` : null}}       
          br/ {{item.data.time? Number(item.data.time.substr(0,2))>12?"PM":"AM" :null}} {{item.data.time? `${item.data.time.substring(0, item.data.time.length - 3)}`: null}} 
        .text-12.mt-20.h-12 {{ tableBarUpdateBehavior(item.data.update_behavior)}}
        .mt-50.flex.flex-col.justify-end.h-60(v-if="item.data.severity.length") 
          .flex.items-center(v-for="e in item.data.severity" :key="e")
            .h-10.w-10.rounded-50.bg-main-red.mr-8.border.border-solid(:class="[styleBall(e)]")   
            .text-12 {{ resultListItem(e) }}
  //- .transition.max-h-0.overflow-hidden(:data="'hasExtend'" :class="{'maxHeight':isExtend[index]}" )    
  //-     slot(:name="'second'" :item="item"  :dataIndex="index" :data="item.data" )
</template>

<script>
import Button from "@/components/Button.vue";
import Checkbox from "@/components/Checkbox.vue";
import { PAGEINDEX } from "@/enum/global";

export default {
  name: "TableBar",
  props: {
    mainData: {
      type: [Object, Array],
      required: true
    },
    optionArr: {
      type: Array,
      require: false
    },
    showLength: {
      type: Boolean,
      require: false,
      default: false
    },
    customIcon: {
      type: String,
      required: false
    },
    height: {
      type: [String, Number],
      required: false,
      default: 64
    },
    fontSize: {
      type: [String, Number],
      required: false,
      default: 14
    },
    extendArr: {
      type: [Array],
      required: false
    },
    allConfig: {
      type: Number
    },
    allConfigId: {
      type: Array
    },
    getDeleteConfigList: {
      type: Function
    }
  },
  components: { Button, Checkbox },
  data() {
    return {
      mainSelect: "",
      obj: [
        { id: "ax", name: "aaaaa" },
        { id: "bx", name: "bbbbb" },
        { id: "cx", name: "ccccc" },
        { id: "dx", name: "ddddd" }
      ],
      isExtend: [],
      localExtendArr: [],
      moreOption: null,
      //checkbox勾選以後加入的陣列
      tablecheck: []
    };
  },
  created() {
    // const containsKey = (obj, key ) => Object.keys(obj).includes(key);
    // this.hasPin = containsKey(this.mainData[0], 'pin');
    // console.log(this.mainData[0]);
  },
  mounted() {
    this.localExtendArr = this.extendArr;
  },
  methods: {
    resultListItem(e){
      let severityList = {
        HIGH : '__c6N3.__high',
        MEDIUM : '__c6N3.__recommend',
        LOW : '__c6N3.__optional',
      }
      return this.$t(severityList[e])
    },
    styleBall(e){
      let severityList = {
        HIGH : 'bg-main-red',
        MEDIUM : 'bg-main-yellow',
        LOW : 'bg-main-green',
      }
      return this.$t(severityList[e])

    },
    tableBarAutoCheckFrequencyDay(e) {
      if (e == "Sunday") {
        return this.$t("__common.__sunday");
      }
      if (e == "Monday") {
        return this.$t("__common.__monday");
      }
      if (e == "Tuesday") {
        return this.$t("__common.__tuesday");
      }
      if (e == "Wednesday") {
        return this.$t("__common.__wednesday");
      }
      if (e == "Thursday") {
        return this.$t("__common.__thursday");
      }
      if (e == "Friday") {
        return this.$t("__common.__friday");
      }
      if (e == "Saturday") {
        return this.$t("__common.__saturday");
      } else {
        return e;
      }
    },
    tableBarAutoCheckFrequency(e) {
      if (e == "Manual") {
        return this.$t("__c6N3.__manual");
      } else if (e == "Weekly") {
        return this.$t("__c6N3.__weekly");
      } else {
        return this.$t("__c6N3.__monthly");
      }
    },
    tableBarUpdateBehavior(e) {
      if (e == "NotifyOnly") {
        return this.$t("__c6N3.__notifyOnly");
      } else {
        return this.$t("__c6N3.__downloadInstall");
      }
    },
    changeValue(v) {
      //勾選把id加入陣列
      this.tablecheck = v;
      this.$emit("getDeleteConfigList", this.tablecheck);
    },
    goDetail(item) {
      this.$router.push({
        name: PAGEINDEX.EXPORTHISTORYDETAIL,
        params: {
          id: item.id
        }
      });
      // store.commit("history/setItem", item);
    },
    openExport(e) {
      this.$emit("openExport", e);
    },
    openDelete(e) {
      this.$emit("openDelete", e);
    },
    showExport(index) {
      this.moreOption = index;
    },
    closeExport() {
      this.moreOption = null;
    },
    pin(i) {
      this.$emit("onClick", i);
    },
    extend(e) {
      this.$set(this.isExtend, e, !this.isExtend[e]);
    },
    // goEach(e){

    // },
    closeExtend() {
      for (let i = 0; i < this.mainData.length; i++) {
        this.isExtend.push(false);
      }
      if (this.extendArr) {
        this.sortExtend();
      }
    },
    sortExtend() {
      let extendIndex = 0;
      this.$nextTick(function() {
        for (let i = 0; i < this.extendArr.length; i++) {
          for (let e = 0; e < this.mainData.length; e++) {
            if (this.mainData[e].id) {
              if (this.mainData[e].id == this.extendArr[i]) {
                // console.log('***',this.mainData[e].id,this.extendArr[i], this.mainData[e].id == this.extendArr[i])
                this.isExtend[e] = true;
                extendIndex = e;
              }
            }
          }
        }
        if (extendIndex) {
          let el = this.$refs.scrollPoint[extendIndex];

          el.scrollIntoView(true);
          setTimeout(() => {
            this.$emit("extendArrChange", false);
          }, 10);
        }
      });
    },
    objectOrg(item) {
      let copyItem = JSON.parse(JSON.stringify(item));
      let temp = [];
      for (const key in copyItem) {
        if (key == "name" || key == "data") {
          copyItem[key] = "";
        }
      }
      temp.push(copyItem);
      return temp;
    }
    // isThisTabShow(item){
    //   // let length = item.data?   item.data.length : 0;
    //   let show = item.length ? true : false;
    //   console.log(item)
    //   return show
    // }
  },
  watch: {
    mainData: {
      handler: function() {
        //驗證有填選則開啟BTN
        this.closeExtend();
        this.tablecheck = [];
      },
      deep: true
    },
    allConfig: {
      handler: function() {
        if (this.allConfig == 1) {
          this.tablecheck = this.allConfigId;
        } else if (this.allConfig == 0) {
          this.tablecheck = [];
        }
      }
    }
  },
  computed: {
    hasPin() {
      const containsKey = (obj, key) => Object.keys(obj).includes(key);
      return containsKey(this.mainData[0], "pin");
    }
  }
};
</script>

<style lang="scss" scoped>
.transition {
  // transition: 0.2s  all  linear;
}

.maxHeight {
  max-height: 9999px;
}

.check {
  position: relative;
  &:after {
    content: "";
    position: absolute;
    left: 4px;
    top: 9px;
    background: rgb(30, 103, 199);
    width: 3px;
    height: 3px;
    box-shadow: 2px 0 0 rgb(30, 103, 199), 4px 0 0 rgb(30, 103, 199), 4px -2px 0 rgb(30, 103, 199),
      4px -4px 0 rgb(30, 103, 199), 4px -6px 0 rgb(30, 103, 199), 4px -8px 0 rgb(30, 103, 199);
    transform: rotate(45deg);
  }
}
</style>
